const { REACT_APP_RECAPTCHA } = process.env;

const strings = {
    appName: 'DHO',

    tableLoadingTip: 'Carregando...',

    discardPromptMessage: 'Deseja descartar as informações do formulário?',

    recaptchaSiteKey: REACT_APP_RECAPTCHA,
};

export default strings;
